import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import CheckboxLabeled from '../../../common/form/CheckboxLabeled';
import { ProspectMessagesSuppressions } from './ProspectMessagesConfigurations';

interface Props {
    messagesSuppressionsValue: number;
    isMobileRedirect: boolean;
    onChange: (newValue: number) => void;
    onChangeMobileRedirect: (newValue: boolean) => void;
    disabled?: boolean;
}

const ProspectMessagesConfigurationSection = (props: Props) => {
    const computeCheckboxValues = (changedBit: number) => {
        let operand = 1 << changedBit;

        props.onChange(props.messagesSuppressionsValue ^ operand);
    };

    const determineCheckedStatus = (flag: ProspectMessagesSuppressions) =>
        (props.messagesSuppressionsValue & flag) !== 0;

    return (
        <div>
            <Row>
                <Col>
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Suppress Prospect Confirmation Messages?'
                        }}
                        inputProps={{
                            id: 'confirmation-messages',
                            name: 'confirmationMessages',
                            checked: determineCheckedStatus(
                                ProspectMessagesSuppressions.Confirmation
                            ),
                            disabled: props.disabled 
                        }}
                        onChange={() => computeCheckboxValues(0)}
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Suppress Prospect Reminder Messages?'
                        }}
                        inputProps={{
                            id: 'reminder-messages',
                            name: 'reminderMessages',
                            checked: determineCheckedStatus(ProspectMessagesSuppressions.Reminder),
                            disabled: props.disabled
                        }}
                        onChange={() => computeCheckboxValues(1)}
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Suppress Prospect Access Messages?'
                        }}
                        inputProps={{
                            id: 'access-messages',
                            name: 'accessMessages',
                            checked: determineCheckedStatus(ProspectMessagesSuppressions.Access),
                            disabled: props.disabled
                        }}
                        onChange={() => computeCheckboxValues(2)}
                    />
                    <CheckboxLabeled
                                        labelProps={{
                                            labelText: 'Suppress Pending Steps Notification'
                                        }}
                                        inputProps={{
                                            id: 'suppress-pending-steps',
                                            name: 'suppressPendingStepsNotification',
                                            checked: determineCheckedStatus(ProspectMessagesSuppressions.PendingSteps),
                                            disabled: props.disabled
                                        }} 
                                        onChange={() => computeCheckboxValues(5)}
                                    />
                    
                </Col>
                <Col>
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Suppress Tour Completion/No-Show Messages?'
                        }}
                        inputProps={{
                            id: 'completion-messages',
                            name: 'completionMessages',
                            checked: determineCheckedStatus(ProspectMessagesSuppressions.Completion),
                            disabled: props.disabled
                        }}
                        onChange={() => computeCheckboxValues(3)}
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Suppress Virtual Tour Reminder Messages?'
                        }}
                        inputProps={{
                            id: 'virtual-tour-reminder-messages',
                            name: 'virtualTourReminderMessages',
                            checked: determineCheckedStatus(
                                ProspectMessagesSuppressions.VirtualTourReminder
                            ),
                            disabled: props.disabled
                        }}
                        onChange={() => computeCheckboxValues(4)}
                    />
                    
                    <CheckboxLabeled
                        labelProps={{
                            labelText: 'Redirect To Mobile App'
                        }}
                        inputProps={{
                            id: 'redirect-to-mobile-app',
                            name: 'redirectToMobileApp',
                            checked: props.isMobileRedirect,
                            disabled: props.disabled
                        }}
                        onChange={() => props.onChangeMobileRedirect(!props.isMobileRedirect)}
                    />
                     
                </Col>
            </Row>
        </div>
    );
};

export default ProspectMessagesConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/ProspectMessagesConfigurationSection.tsx